import React, { useState } from "react";

import "./IdInput.scss";

interface IIdInput {
  idValue?: string | null;
  setIdValue?: React.Dispatch<React.SetStateAction<string | null>>;
}

const IdInput = ({ idValue, setIdValue }: IIdInput) => {
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIdValue && setIdValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (idValue && idValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={idValue || ""}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">ID</span>
        </label>
      </div>
    </div>
  );
};

export { IdInput };
